
import { requestB2BChallenge } from '@/api'
import cookies from 'js-cookie'

// 미션정보 조회
const ENDPOINT_B2BMISSION_MISSIONFORMPROPERTY = 'ClientMission/MissionFormProperty'
// 미션정보 저장
const ENDPOINT_B2BMISSION_EXECUTE = 'ClientMission/Execute'

export default {
  namespaced: true,
  state: {
    missionData: null,
    missionFormData: null,
    log: '',
  },
  actions: {
    // 입력 형식 폼 조회
    async getMissionForm ({ state }, payload) {
      const resp = await requestB2BChallenge(ENDPOINT_B2BMISSION_MISSIONFORMPROPERTY, 'post', {
        challengeId: cookies.get('ChallengeID'),
        cuId: cookies.get('CUID'),
        missionDateString: payload.missionDateString,
        missionType: payload.missionType,
        missionCode: payload.missionCode,
        baseInfo: {
          appType: cookies.get('AppType'),
          appVersion: cookies.get('AppVersion'),
          language: cookies.get('LanguageCode'),
          country: cookies.get('CountryCode'),
          utcInterval: cookies.get('UTCInterval'),
        }
      })

      if (resp.data !== undefined && resp.data !== null) {
        console.log('mission form data:', resp.data)
        state.missionData = resp.data
        state.missionFormData = resp.data.missionFormPropertyList
      }
    },
    // 식단 등록 항목 반환
    async setMissionForm ({ state },payload) {
      const resp = await requestB2BChallenge(ENDPOINT_B2BMISSION_EXECUTE, 'put', {
        missionKey: payload.missionKey,
        challengeId: cookies.get('ChallengeID'),
        cuId: cookies.get('CUID'),
        missionDateString: payload.missionDateString,
        missionType: payload.missionType,
        missionCode: payload.missionCode,
        propertyValueList: payload.propertyValueList,
        baseInfo: {
          appType: cookies.get('AppType'),
          appVersion: cookies.get('AppVersion'),
          language: cookies.get('LanguageCode'),
          country: cookies.get('CountryCode'),
          utcInterval: cookies.get('UTCInterval'),
        }
      })

      if (resp.data !== undefined && resp.data !== null) {
        console.log('mission form data:', resp.data, state)
      }

      return resp
    }
  },
  mutations: {
  }
}
